"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(MUITheme => ({
  root: props => {
    const rootStyles = {
      fontFamily: MUITheme.typography.fontFamily,
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: 1.25,
      padding: "13px 28px 11px",
      lineHeight: "16px",
      borderWidth: props === null || props === void 0 ? void 0 : props.borderWidth,
      borderStyle: props === null || props === void 0 ? void 0 : props.borderStyle,
      borderColor: props === null || props === void 0 ? void 0 : props.borderColor,
      borderRadius: 4,
      color: props === null || props === void 0 ? void 0 : props.color,
      backgroundColor: props === null || props === void 0 ? void 0 : props.backgroundColor,
      border: props === null || props === void 0 ? void 0 : props.border,
      boxShadow: props === null || props === void 0 ? void 0 : props.boxShadow,
      "&:hover": props === null || props === void 0 ? void 0 : props.hover,
      "&:disabled": {
        backgroundColor: MUITheme.palette.background.disabled.gray,
        color: MUITheme.palette.text.lightGrey
      },
      transition: "all 0.1s"
    };
    return rootStyles;
  }
}));